module.exports = __webpack_public_path__ + "static/media/exlamation.0cb8b9f7.svg";